import { CACHE_KEY, EXPIRED } from 'favorite/constants/constants'
import type { StorageInstance } from 'storage/domain/Storage'
import { getStorageInstance } from 'storage/services/getStorageInstance'
import type { StorageProps } from 'storage/types'

let cacheInstance: StorageInstance | null = null

export const getCacheInstance = () => cacheInstance

export const getFavoritesStorage = (
	logged = false,
	token?: string
): StorageInstance | null => {
	if (cacheInstance) {
		return cacheInstance
	}

	if (token) {
		const payload: StorageProps = {
			cacheKey: CACHE_KEY,
		}
		if (logged) {
			payload.maxDiffTimestamp = EXPIRED
			payload.token = token
		}
		cacheInstance = getStorageInstance(payload)
	}

	return cacheInstance
}

export const resetFavoritesCache = () => {
	cacheInstance = null
}
